import { gql } from "@apollo/client";

export const ADD_OR_UPDATE_ADDRESS = gql`
  mutation addOrUpdateAddress($input: AddOrUpdateAddressInput!) {
    addOrUpdateAddress(input: $input) {
      address {
        city
        id
        lat
        lng
        name
        state
        streetName
        streetNumber
        unit
        validAddressAlerts {
          alertType {
            id
            name
            alertLevel
            oriId
            position
          }
          createdAt
          officer {
            deptAttribute {
              id
              badge
              ori {
                id
                abbreviation
              }
            }
            personalAttribute {
              id
              firstName
              lastName
            }
          }
          expireAt
          id
          notes
        }
        zip
      }
      uuid
      clientMutationId
      errors
    }
  }
`;
